import { createHashHistory } from 'history';

export const routerHistory = createHashHistory({});
